import React , { useEffect, useState } from 'react'; 
import storage from '../factory/StorageFactory.js';
// import '../styles/card-style.css';
import FormContainer from '../components/FormContainer.jsx';
import { FaCheck, FaTimes } from 'react-icons/fa';
import config from '../appconfig/config.json';

const InvalidDirectors = (props) => {
    const [errCode,setErrCode] = useState();
    const [errMsg,setErrMsg] = useState();
  
    useEffect(() => {
 
        window.scrollTo(0,0);
        const errType = props.location.state.errType;
        setErrCode(errType);
        if(errType === 'M10') {
            setErrMsg('Business has up to 5 Singaporeans/Singapore PRs Partners, Business Owner, Directors, Shareholders'); 
        }
        else {
            setErrMsg('Business has up to 10 Singaporeans/Singapore PRs Partners, Business Owner, Directors, Shareholders'); 
        }
        storage.clearAll();
     }, []);

    const handleOnClick = () => {
        window.location.href = config.link.GetInTouch;
    }

    const handleCancelClick = ()=> {
        window.location.href = config.link.Cancle;
    }

    return(
        <FormContainer>
            <div className="row around-xs inputPair elementVisible">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <legend id={'lmsg1'} style={{paddingTop:'20px'}}>{'Oops!'}</legend>
                </div>
            </div>
            <div style={{paddingTop: "10px"}}><hr className="yellowPanelLine" /></div>
            <div className="row around-xs inputPair elementVisible">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div id={'lmsg1'} style={{paddingTop:'20px',whiteSpace:'pre-line'}}>
                    {'We are unable to process your online application. <Code '+errCode+'>'}</div>
                </div>
             </div>
            <br/>
            <div className="box">
                <FaCheck color='green'/>&nbsp;&nbsp;{'Business is incorporated in Singapore '} 
            </div>
            <br/>
            <div className="box">
                <FaTimes color='red'/>&nbsp;&nbsp;{errMsg}
            </div>   
            <br/>   
            <div className="box">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'For assistance, do get in touch.'} 
            </div>            
            <br/> <br/>
            <div className="row around-xs inputPair elementVisible">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{ paddingBottom: "20px" }}>
                    <button type={'submit'} className="k-button btn-success" onClick={handleOnClick}>{'Get in Touch'}</button>
                    <button className="k-button btn-back btn-float-right" onClick={handleCancelClick}>{'Cancel'}</button>
                </div>
            </div>  
        </FormContainer>
    )
}

export default InvalidDirectors;